// Logotipo e isotipo de Solarix. Los SVG son copia de Propuesta v2/plantilla/assets/logo/ (de la marca medida en
// ~/Desktop/Solarix/MARCA.md). El logotipo toma el color del texto que lo rodea (currentColor): blanco sobre noche,
// prusia sobre claro. Nunca se redibuja.
import logotipoSvg from '../marca/logotipo.svg?raw';
import isotipoSvg from '../marca/isotipo-placa.svg?raw';

const LOGOTIPO = logotipoSvg
  .replace(/fill="#1E3F64"/gi, 'fill="currentColor"')
  .replace(/\swidth="[^"]*"/, '')
  .replace(/\sheight="[^"]*"/, '')
  .replace(/role="img"\s*/, '')
  .replace(/aria-label="[^"]*"\s*/, '')
  .replace(/<title>[^<]*<\/title>/, '');

if (!LOGOTIPO.includes('currentColor')) throw new Error('marca.tsx: el logotipo ya no trae el azul #1E3F64 que se cambia por currentColor');

export function Logotipo({ className }: { className?: string }) {
  return <span className={['logotipo', className ?? ''].join(' ')} role="img" aria-label="Solarix Energy" dangerouslySetInnerHTML={{ __html: LOGOTIPO }} />;
}

export function Isotipo({ className }: { className?: string }) {
  return <span className={['isotipo', className ?? ''].join(' ')} aria-hidden dangerouslySetInnerHTML={{ __html: isotipoSvg }} />;
}
